import { Component, Output, EventEmitter } from '@angular/core';
import { AppState } from '../../config/state';
import { Events } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';

/**
 * Generated class for the CoRecentAccountsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-recent-accounts',
  templateUrl: 'co-recent-accounts.html'
})
export class CoRecentAccountsComponent {

  text: string;
  accounts: Array<any>;
  @Output() closeModal = new EventEmitter<any>();
  constructor(private state : AppState, private events : Events, private loginProvider : LoginProvider) {
    this.accounts = this.state.recentAccounts;
  }

  chooseAccount(barcode, pin?){
    this.closeModal.emit({barcode: barcode, pin: pin || false});
  }

}



// WEBPACK FOOTER //
// ./src/components/co-recent-accounts/co-recent-accounts.ts